import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationHandler } from '../../helper/notification.handler';
import { MatSelectChange } from '@angular/material/select';
import { Role } from '../../model/auth/Role';
import { Observable } from 'rxjs';

@Component({
  selector: 'item-select',
  templateUrl: './item-select.component.html',
  styleUrls: ['./item-select.component.scss']
})
export class ItemSelectComponent<T> {

  @Input() roles!: Role[];

  @Input() label!: string;
  @Input() noItemsLabel?: string;
  @Input() disabled = false;

  @Input() compareWith!: (i1?: T, i2?: T) => boolean;
  @Input() displayWith!: (item: T) => string;
  @Input() loadWith!: () => Observable<T[]>;
  @Input() selectedItem?: T;

  @Output() selected = new EventEmitter<T>();

  items!: T[] | null;

  constructor() {
  }

  initContent() {
    this.loadItems();
  }

  private loadItems() {
    this.items = null;

    this.loadWith().subscribe({
      next: items => {
        this.items = items;

        if (this.selectedItem) {
          const selected = this.items.filter(item => this.compareWith(item, this.selectedItem));
          if (selected && selected.length > 0) {
            this.selected.emit(selected[0]);
          }
        }
      }, error: error => {
        NotificationHandler.handleError($localize`:Notifications|Items fetch has failed message@@notifications-items-fetch-failed-failed-error:Items fetch has failed`, error);
      }
    });
  }

  itemSelected(change: MatSelectChange) {
    this.selected.emit(change.value as T);
  }

}
